module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/vux/~/axios/index.js
// module id = 563
// module chunks = 0